import React, { Component } from "react";
import { connect } from "react-redux";
import {
  userGet,
  getCustomer,
  userUpdateAndList,
  customerUpdate,
  passwordChange,
  getDataRequestSettings,
  submitDataRequest,
  customerSelect,
  countryStateList, getSmartFlagProfiles, checkArchive
} from "../../redux/actions";

import {
  getActiveLanguage
} from 'react-localize-redux'

import { removeLogo } from "../../common/storage";

import Profile from "../../components/profile";
import next from "../../components/common/results/views/next";
import {getAppSetting} from "../../redux/actions/appSettingActions";

class ProfilePage extends Component {
  removeLogo = id => {
    removeLogo("org", id);
  };

  render() {
    const {
      translate,
      profile,
      user,
      userUpdateAndList,
      customer,
      customerUpdate,
      passwordChange,
      languages,
      impersonating,
      currentLoggedInUserId,
      countryStates,
      getDataRequestSettings,
      submitDataRequest,
      smartFlagProfiles,
      checkArchive,
    } = this.props;

    return (
      <Profile
        profile={profile}
        user={user && user.id === currentLoggedInUserId ? user : null}
        userUpdateAndList={userUpdateAndList}
        customer={customer}
        customerUpdate={customerUpdate}
        passwordChange={passwordChange}
        languages={languages}
        translate={translate}
        impersonating={impersonating}
        removeLogo={ this.removeLogo }
        countryStates={countryStates}
        getDataRequestSettings={getDataRequestSettings}
        submitDataRequest={submitDataRequest}
        smartFlagProfiles={smartFlagProfiles}
        activeFeatures={this.props.activeFeatures}
        checkArchive={checkArchive}
      />
    );
  }

  componentDidMount() {
    const { profile, getSmartFlagProfiles, userGet, getCustomerWithLogo,
      getCountryStateList, activeLanguage } = this.props;

    if (profile && profile.id) {
      userGet(profile.id);
    }
    if (profile && profile.customerid) {
      getCustomerWithLogo(profile.customerid);
      if (this.props.activeFeatures?.some(f => f.featureName === 'smart_flag')) {
        getSmartFlagProfiles(profile.customerid);
      }
    }
    getCountryStateList(activeLanguage);
  }
}

const mapStateToProps = state => ({
  profile: state.profileReducer.profile,
  user: state.userReducer.user,
  customer: state.customerReducer.customer,
  languages: state.localeReducer.languages,
  impersonating: state.userReducer.impersonating,
  currentLoggedInUserId: state.userReducer.currentLoggedInUserId,
  countryStates: state.customerReducer.countryStates,
  activeLanguage: getActiveLanguage(state.localeReducer).code,
  smartFlagProfiles: state.smartFlagProfileReducer.profiles,
  activeFeatures: state.appSettingReducer?.activeFeatures ?? [],
  ...state
});

const mapDispatchToProps = (dispatch, props) => ({
  userGet: id => {
    dispatch(userGet(id));
  },
  getCustomer: id => {
    dispatch(getCustomer(id));
  },
  userUpdateAndList: user => {
    return dispatch(userUpdateAndList(user));
  },
  customerUpdate: customer => {
    return dispatch(customerUpdate("org", customer));
  },
  passwordChange: data => {
    return dispatch(passwordChange(data));
  },
  getCustomerWithLogo: id => {
    return dispatch(customerSelect(id));
  },
  getCountryStateList: (languageCode) => {
    dispatch(countryStateList(languageCode));
  },
  getDataRequestSettings: () => {
    return dispatch(getDataRequestSettings());
  },
  submitDataRequest: () => {
    return dispatch(submitDataRequest());
  },
  getSmartFlagProfiles: (organisationId) => {
    dispatch(getSmartFlagProfiles(organisationId));
  },
  checkArchive: (cid) => {
    dispatch(getAppSetting()).then((result) => {
      const activeFeatures = result?.payload?.data?.activeFeatures;
      if (activeFeatures?.some(f => f.featureName === 'automated_archiving')) {
        dispatch(checkArchive(cid));
      }
    });
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProfilePage);
